import { render, staticRenderFns } from "./care.vue?vue&type=template&id=498c5fae&scoped=true&"
import script from "./care.vue?vue&type=script&lang=js&"
export * from "./care.vue?vue&type=script&lang=js&"
import style0 from "./care.vue?vue&type=style&index=0&id=498c5fae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498c5fae",
  null
  
)

export default component.exports